// @flow
import React from 'react';

// Logo «G» de Google a color (mismo SVG que el botón de login con Google).
// El tamaño lo fija el CSS del botón contenedor.
export const GoogleIcon = () => (
  <svg viewBox="0 0 535 545" version="1.1" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(0.000000, -1.000000)" fillRule="nonzero">
        <path
          d="M534.5,279.4 C534.5,260.9 533,242.3 529.8,224.1 L273.1,224.1 L273.1,328.9 L420.1,328.9 C414,362.7 394.4,392.6 365.7,411.6 L365.7,479.6 L453.4,479.6 C504.9,432.2 534.5,362.2 534.5,279.4 Z"
          fill="#4285F4"
        />
        <path
          d="M273.1,545.3 C346.5,545.3 408.4,521.2 453.5,479.6 L365.8,411.6 C341.4,428.2 309.9,437.6 273.2,437.6 C202.2,437.6 142,389.7 120.4,325.3 L29.9,325.3 L29.9,395.4 C76.1,487.3 170.2,545.3 273.1,545.3 Z"
          fill="#34A853"
        />
        <path
          d="M120.3,325.3 C108.9,291.5 108.9,254.9 120.3,221.1 L120.3,151 L29.9,151 C-8.7,227.9 -8.7,318.5 29.9,395.4 L120.3,325.3 Z"
          fill="#FBBC04"
        />
        <path
          d="M273.1,108.7 C311.9,108.1 349.4,122.7 377.5,149.5 L377.5,149.5 L455.2,71.8 C406,25.6 340.7,0.2 273.1,1 C170.2,1 76.1,59 29.9,151 L120.3,221.1 C141.8,156.6 202.1,108.7 273.1,108.7 Z"
          fill="#EA4335"
        />
      </g>
    </g>
  </svg>
);
